<template>
    <div>
        <slot name="elments" v-bind="{ ...$props }" :valueSelected="valueSelected" :onTriggerClick="onTriggerClick">
            <template v-for="elm in data">
                <div class="custom-control custom-radio custom-control-inline">
                    <input type="radio" :id="'radio-' + elm.value" class="custom-control-input" v-on:change="onTriggerClick(elm)" :checked="elm.value === valueSelected">
                    <label class="custom-control-label" :for="'radio-' + elm.value">{{elm.label}}</label>
                </div>
            </template>
        </slot>
        <div style="display:none">
            <slot name="hidden">
                <input type="hidden" :name="name" :value="valueSelected">
            </slot>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            name:  {
                type: [String],
                default: ''
            },
            valueDefault: {
                type: [String, Number],
                default: 0
            },
            data: {
                type: Array,
                default: () => []
            }
        },
        data() {
            return {
                valueSelected: null
            };
        },
        mounted() {
            this.valueSelected = this.valueDefault;
        },
        methods: {
            onTriggerClick(elm) {
                this.valueSelected = elm.value;
            }
        }
    }
</script>
